import { useEffect } from 'react'
import { showAppToast } from '@/components/AppToaster'
import { toast } from '@/utilities/toast'

/**
 * Bridges the standalone toast pub/sub utility to the app toaster (sonner)
 * for rendering.
 *
 * Mount this component once near the app root (next to `<AppToaster />`).
 * It subscribes to toast events and forwards them with the appropriate
 * timeouts.
 *
 * This replaces the Redux-connected Alert component for any code
 * that uses the `toast` utility instead of `dispatch(Alert(...))`.
 */
const ToastListener = () => {
  useEffect(() => {
    const unsubscribe = toast.subscribe(event => {
      switch (event.type) {
        case 'success':
          showAppToast('success', event.message, 5000)
          break
        case 'error':
          showAppToast('error', event.message, 10000)
          console.error('Toast error:', event.message)
          break
        case 'info':
          showAppToast('info', event.message, 10000)
          break
      }
    })

    return unsubscribe
  }, [])

  return null
}

export default ToastListener
